import { BorrowFollowEightContainer } from "../../containers/borrowSystem/BorrowFollowEightContainer";

export function BorrowFollowEightPage() {
    return (
        <BorrowFollowEightContainer />
    )
}
